/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useAuthActions } from '../../hooks/useAuthActions';
import PremiumAchievementNotification from '../Achievements/PremiumAchievementNotification';

const AchievementProvider = ({ children }) => {
  const [currentAchievement, setCurrentAchievement] = useState(null);
  const [showNotification, setShowNotification] = useState(false);
  
  // Initialize auth-related achievement tracking
  useAuthActions();

  useEffect(() => {
    // Listen for achievement notifications
    const handleAchievementUnlock = (event) => {
      const achievement = event.detail;
      setCurrentAchievement(achievement);
      setShowNotification(true);
    };

    window.addEventListener('achievementUnlocked', handleAchievementUnlock);
    return () => window.removeEventListener('achievementUnlocked', handleAchievementUnlock);
  }, []);

  const handleCloseNotification = () => {
    setShowNotification(false);
    setCurrentAchievement(null);
  };

  return (
    <>
      {children}
      <PremiumAchievementNotification
        achievement={currentAchievement}
        show={showNotification}
        onClose={handleCloseNotification}
      />
    </>
  );
};

export default AchievementProvider;